import context from './context';

const RootContextProvider = context.Provider;

export default RootContextProvider;
